import { render, staticRenderFns } from "./EducationCredentialsDialog.vue?vue&type=template&id=6cefa976"
import script from "./EducationCredentialsDialog.vue?vue&type=script&lang=ts"
export * from "./EducationCredentialsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports